// extracted by mini-css-extract-plugin
export default {"errMsg":"ErrorMessage_errMsg__s2KqH","show":"ErrorMessage_show__+d9Ym"};